import React from 'react';
import styles from './SearchTables.module.scss';

export default function Title({ title }) {
  return <h2 className={styles.title}>{title}</h2>;
}
